module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_EL-4917d50f122f5de2a14208b16419de8d.svg";